// extracted by mini-css-extract-plugin
module.exports = {"label":"FormCheckbox_label__2yn8l"};